export const useVersionV2 = () => {
  return {
    version: 'v2',
    message: 'This is version 2',
    name: 'versionV2',
  };
};
